import money from './Format/Money'
import phone from './Format/Phone'
import mobile from './Format/Mobile'
import zip from './Format/Zip'
import nationalNumber from './Format/NationalNumber/NationalNumber'
import orginizationNumber from './Format/OrganizationNumber/OrganizationNumber'
import date from './Format/Date'
import companyName from './Format/Text/CompanyName'
import email from './Format/Text/Email'
import firstName from './Format/Text/FirstName'
import fullName from './Format/Text/FullName'
import lastName from './Format/Text/LastName'
import text from './Format/Text/Text'
import varchar from './Format/Text/Varchar'
import dummyPhone from './Format/DummyPhone'
import configHandler from './configHandler'

const L10n = {

    config: configHandler,

    boot: function (options) {
        configHandler.boot(options)
    },

    // Eslint ignores unused options - defined for future use
    //eslint-disable-next-line
    install: function (Vue, options) {
        Vue.prototype.L10n = this
        Vue.prototype.$t_money = (amount, decimals, withCurrency) => {
            return money.parse(amount).format(decimals, withCurrency)
        }
        Vue.prototype.$t_phone = (number, countryCode) => {
            return phone.parse(number, countryCode).format()
        }
        Vue.prototype.$t_mobile = (number, countryCode) => {
            return mobile.parse(number, countryCode).format()
        }
        Vue.prototype.$t_zip = (zipCode) => {
            return zip.parse(zipCode).format()
        }
    },

    money,
    phone,
    zip,
    nationalNumber,
    orginizationNumber,
    dummyPhone,
    email,
    text,
    birthdate: nationalNumber,
    companyName,
    firstName,
    lastName,
    fullName,
    varchar,
    date,
    mobile,

}

export default L10n